import { makeRequest } from '@dealstack/frontend/shared/dataExchange/ApiLayer/apiLayer';
import { HTTP_METHOD } from '@dealstack/shared/lib/common/dataExchange/common';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths';
import * as ApiV1 from '@dealstack/shared/lib/common/dataExchange/apiV1';
import { formatUnicorn } from '@dealstack/shared/lib/format/formatUnicorn';
import { BasicUserWithPermissionsRes } from '@dealstack/shared/lib/generated';
import { useQuery } from '@tanstack/react-query';
import { TransformedPermission } from '@dealstack/frontend/shared/components/UserPermissions/UserPermissions.types';

const getOrganizationUser = async ({
	userId,
	organizationId,
}: {
	userId: string;
	organizationId: string;
}) => {
	const endpoint = formatUnicorn(API_PATHS.ORGANIZATION_ORGANIZATIONID_USERS_USERID_GET, {
		organizationId,
		userId,
	});
	const result = await makeRequest<ApiV1.Response<BasicUserWithPermissionsRes>>({
		endpoint,
		method: HTTP_METHOD.GET,
	});

	if (!result.payload) {
		throw new Error('User not found');
	}

	return result.payload;
};

export const useOrganizationUser = ({
	userId,
	organizationId,
	select,
	enabled,
}: {
	userId: string;
	organizationId: string;
	select?:
		| ((data: BasicUserWithPermissionsRes) => Omit<
				BasicUserWithPermissionsRes,
				'permissions'
		  > & {
				permissions: TransformedPermission[];
		  })
		| undefined;
	enabled: boolean;
}) => {
	return useQuery({
		queryKey: [
			formatUnicorn(API_PATHS.ORGANIZATION_ORGANIZATIONID_USERS_USERID_GET, {
				organizationId,
				userId,
			}),
		],
		queryFn: () => getOrganizationUser({ userId, organizationId }),
		enabled,
		select,
	});
};
